import * as actionTypes from "../actions/actionTypes";

const initialState = {
    facilities: []
};

const facilityReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case actionTypes.SET_FACILITIES:
        return { ...state, facilities: payload };
  
      default:
        return state;
    }
  };

  export default facilityReducer;